import React from 'react';

import { UploadStepsEnum } from '../../../../../constants/addressBook';
import { TParsedData } from '../../../../../types/addressBook';
import { ImportAddressesStep, MapColumnsStep, RepairAddressesStep, UploadAddressesStep } from '../../steps';

interface IProps {
  currentStep: number;
  dataAddresses: TParsedData[] | null;
  onClose: () => void;
}

const StepContent: React.FC<IProps> = ({ currentStep, dataAddresses, onClose }) => {
  switch (currentStep) {
    case UploadStepsEnum.Upload:
      return <UploadAddressesStep />;
    case UploadStepsEnum.Map:
      return dataAddresses ? <MapColumnsStep /> : null;
    case UploadStepsEnum.Repair:
      return dataAddresses ? <RepairAddressesStep /> : null;
    case UploadStepsEnum.Import:
      return <ImportAddressesStep closeModal={onClose} />;
    default:
      return null;
  }
};

export default StepContent;
